import BaseModel from '@/models/BaseModel.js'

export default class CraftDetail extends BaseModel {
    fields =  {
      'uraian': {
        label: 'Uraian',
        type: 'text',
        rules: 'required'
      },
      'size': {
        type: 'text',
        rules: 'required'
      },
      'berat': {
        skipPriceTag: true,
        label: 'Berat (gram)',
        type: 'price',
        rules: 'required'
      },
      'harga': {
        label: 'Harga',
        type: 'price',
        rules: 'required'
      },
      'foto': {
        label: 'Foto',
        type: 'image',
        rules: null
      },
    }
    endpoint = process.env.VUE_APP_API_URL + 'crafts'
}